// extracted by mini-css-extract-plugin
export default {"editable":"Editable_editable__Is5wW","editableTextArea":"Editable_editableTextArea__rhlnL"};